import { useCallback, useMemo } from 'react';

import { useLocation } from '@tanstack/react-router';

import { useAuthContext } from './context';
import { useLocalPermissions } from './use-local-permissions';

export function usePermissions() {
  const { pathname } = useLocation();
  const { permissions } = useAuthContext();

  const localPermissionsFunc = useLocalPermissions(permissions);

  const { getModelPermissionByPath, getPermissionModelDetailsByPath } = localPermissionsFunc;

  const getCurrentModelPermissions = useCallback(() => {
    const { modelPath } = getPermissionModelDetailsByPath(pathname);

    return getModelPermissionByPath(modelPath);
  }, [getPermissionModelDetailsByPath, getModelPermissionByPath, pathname]);

  const currentModelPermissions = useMemo(() => {
    return getCurrentModelPermissions();
  }, [getCurrentModelPermissions]);

  return {
    ...localPermissionsFunc,
    currentModelPermissions,
    getCurrentModelPermissions,
  };
}
